exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog-time-difference[data-v-d8af0a00]{z-index:2400!important}", ""]);

// exports
